import { States } from "./States";

const moment = require( 'moment' );
import * as IF from "infrontjs";
import { View } from "./View";
import { Gui } from "./Gui";
import { Storage } from "./Storage";
import { RoutinenManager } from "./RoutinenManager";
import { Api } from "./Api";
import { CurrentUser } from "../model/CurrentUser";

import { RegistrationState } from "../states/auth/RegistrationState";
import { TokenState } from "../states/auth/TokenState";
import { LoginState } from "../states/auth/LoginState";
import { IndexState } from "../states/index/IndexState";
import { VideoSelectionState } from "../states/video/VideoSelectionState";
import { AccountingIndexState } from "../states/accounting/AccountingIndexState";
import { LogoutState } from "../states/auth/LogoutState";
import { AccountState } from "../states/account/AccountState";
import { RequestPasswordResetState } from "../states/auth/RequestPasswordResetState";
import { PaymentWallState } from "../states/index/PaymentWallState";
import { RoutineSettingsState } from "../states/routine/RoutineSettingsState";
import { PremiumState } from "../states/account/PremiumState";
import { VideoCategoryState } from "../states/video/VideoCategoryState";
import { PaInfoState } from "../states/index/PaInfoState";

import appSettings from  './../settings.json';
import config from './../config.json';

export class Youtine extends IF.App
{
    constructor()
    {
        super( document.querySelector( '#page' ), appSettings );
        this.config = new IF.PathObject( config );

        // Overwrite default view
        this.states = new States( this );
        this.view = new View( this );
        this.gui = new Gui( this );
        this.api = new Api( this.config.get( 'services.youtine.url' ) );
        this.storage = new Storage( this );

        if ( true === this.isNativeMobile() || true === this.storage.loadIsSoi() )
        {
            document.querySelector( 'body' ).classList.add( 'env-native-mobile' );
        }
        else
        {
            document.querySelector( 'body' ).classList.add( 'env-web' );
        }

        this.routineManager = new RoutinenManager();
    }

    async run( route = null)
    {
        await this.init();
        await super.run( route );
        setTimeout( () => {
            this.gui.hideLoader();
        }, 500 );
    }

    async init()
    {
        // Fix bug with back button
        window.addEventListener( 'popstate', ( e ) =>
        {
            this.router.processUrl();
            e.preventDefault();
        });

        this.currentUser = null;
        this._initMoment();
        await this.resolveSession();
        this.states.add(
            RegistrationState,
            TokenState,
            LoginState,
            IndexState,
            VideoSelectionState,
            AccountingIndexState,
            LogoutState,
            AccountState,
            RequestPasswordResetState,
            PaymentWallState,
            RoutineSettingsState,
            PremiumState,
            PaInfoState,
            VideoCategoryState
        );
    }

    async resolveSession()
    {
        const localSessionToken = this.storage.loadSessionToken();
        if ( localSessionToken )
        {
            const response = await this.api.get( '/auth/session/' + localSessionToken );
            if ( response && 200 === response.status )
            {
                // Retrieve user data
                const sessionData = await response.json();
                if ( sessionData && sessionData.hasOwnProperty( 'user' ) )
                {
                    this.currentUser = new CurrentUser( sessionData.user );
                    this.api.setSessionToken( localSessionToken );

                    if ( false === this.isNativeMobile() )
                    {
                        setTimeout( () => {
                            try {
                                    OneSignal.Slidedown.promptPush();
                            } catch ( e ) { }
                        }, 2000 );
                    }
                }
            }
            else
            {
                this.storage.deleteSessionToken();
            }
        }
    }

    isNativeMobile()
    {
        if ( window && window.self !== window.top )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    _initMoment()
    {
        function processRelativeTime(number, withoutSuffix, key, isFuture) {
            var format = {
                m: ['eine Minute', 'einer Minute'],
                h: ['eine Stunde', 'einer Stunde'],
                d: ['ein Tag', 'einem Tag'],
                dd: [number + ' Tage', number + ' Tagen'],
                w: ['eine Woche', 'einer Woche'],
                M: ['ein Monat', 'einem Monat'],
                MM: [number + ' Monate', number + ' Monaten'],
                y: ['ein Jahr', 'einem Jahr'],
                yy: [number + ' Jahre', number + ' Jahren'],
            };
            return withoutSuffix ? format[key][0] : format[key][1];
        }
        moment.locale('de', {
            months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
            monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
            monthsParseExact : true,
            weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
            weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
            weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
            weekdaysParseExact : true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD.MM.YYYY',
                LL: 'D. MMMM YYYY',
                LLL: 'D. MMMM YYYY HH:mm',
                LLLL: 'dddd, D. MMMM YYYY HH:mm',
            },
            calendar: {
                sameDay: '[heute um] LT [Uhr]',
                sameElse: 'L',
                nextDay: '[morgen um] LT [Uhr]',
                nextWeek: 'dddd [um] LT [Uhr]',
                lastDay: '[gestern um] LT [Uhr]',
                lastWeek: '[letzten] dddd [um] LT [Uhr]',
            },
            relativeTime: {
                future: 'in %s',
                past: 'vor %s',
                s: 'ein paar Sekunden',
                ss: '%d Sekunden',
                m: processRelativeTime,
                mm: '%d Minuten',
                h: processRelativeTime,
                hh: '%d Stunden',
                d: processRelativeTime,
                dd: processRelativeTime,
                w: processRelativeTime,
                ww: '%d Wochen',
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: '%d.',
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4, // The week that contains Jan 4th is the first week of the year.
            }
        });
    }
}
